import { Box, ClickAwayListener, IconButton, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import React, { FC, useState } from "react";
import { UserInfo as UserInfoModel } from "../../../../reducers/states/user-info";
import UserInfo from "../user-info-display";

const UserInfoTooltip: FC<{user: UserInfoModel}> = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <Box onClick={() => setIsOpen(true)}>
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={() => setIsOpen(false)}
          open={isOpen}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={<UserInfo userInfo={user} />}
        >
          <IconButton size="large">
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </ClickAwayListener>
  );
};

export default UserInfoTooltip;
